import { CollaborateWrapper } from './style';

// Libs
import Translation from 'libs/Translation';

// Components
import Text from 'components/common/Text';
import Carousel from 'components/common/Carousel';
import CollaborateItem from './CollaborateItem'; 
import Container from 'components/common/Layout/Container';

const Collaborate = ({ webConfig }) => {
    const items = [
        { id: 0, link: '/dr/bonabi', image: '/nextasset/images/home/bonabi.jpeg', title: Translation.t('title.dr-bonabi'), subtitle: Translation.t('label.desc.collaborate1') },
        { id: 1, link: '/dr/hooshmand', image: '/nextasset/images/home/hooshmand.jpeg', title: Translation.t('title.dr-hooshmand'), subtitle: Translation.t('label.desc.collaborate2') },
        { id: 2, link: '/dr/agah', image: '/nextasset/images/home/agah.jpeg', title: Translation.t('title.dr-agah'), subtitle: Translation.t('label.desc.collaborate3') }
    ]

    return (
        <CollaborateWrapper>
            <Container>
                <div className='wrapper'>
                    <Text
                        className='title'
                    >   
                        {Translation.t('title.drs-collaborate')}
                    </Text>
                    <div className='collaborates'>
                    {items.map(i => 
                        <CollaborateItem 
                            key={i.id}
                            item={i}
                            webConfig={webConfig}
                        />
                    )}
                    </div>
                    <div className='carousel'>
                        <Carousel
                            id="collaborate"
                            arrow={false}
				            items={items}
                            padding={true}
				            renderItem={item => <CollaborateItem webConfig={webConfig} {...item} />}
			            />
                    </div>
                </div>
            </Container>
        </CollaborateWrapper>
    )
}

export default Collaborate;